import { Check, ChevronDown } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import type { NewsStatus } from "../types";

const options: Array<{ value: NewsStatus; label: string; description: string }> = [
  { value: "draft", label: "Entwurf", description: "Noch nicht öffentlich sichtbar" },
  { value: "published", label: "Veröffentlicht", description: "Auf der Website sichtbar" },
  { value: "archived", label: "Archiviert", description: "Nur noch im Adminbereich" },
];

export function NewsStatusSelect({ value, onChange }: { value: NewsStatus; onChange: (value: NewsStatus) => void }) {
  const [open, setOpen] = useState(false);
  const controlRef = useRef<HTMLDivElement>(null);
  const selected = options.find((option) => option.value === value) || options[0];

  useEffect(() => {
    if (!open) return;
    const close = (event: MouseEvent) => {
      if (!controlRef.current?.contains(event.target as Node)) setOpen(false);
    };
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", close);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("mousedown", close);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [open]);

  return (
    <div className="status-select-control" ref={controlRef}>
      <button type="button" className={`status-select status-select--${value}`} aria-haspopup="listbox" aria-expanded={open} onClick={() => setOpen((current) => !current)}>
        <span>{selected.label}</span><ChevronDown className={open ? "open" : ""} />
      </button>
      {open && (
        <div className="status-select-options" role="listbox" aria-label="Beitragsstatus">
          {options.map((option) => (
            <button
              type="button"
              role="option"
              aria-selected={option.value === value}
              className={option.value === value ? "selected" : ""}
              key={option.value}
              onClick={() => { onChange(option.value); setOpen(false); }}
            >
              <span className={`status-option-dot status-option-dot--${option.value}`} />
              <span><strong>{option.label}</strong><small>{option.description}</small></span>
              {option.value === value && <Check />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
